import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { removeColorIdForIri } from 'src/containers/ProjectDiagram/utils/colorIds';
import { removeDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { removeGeoDataForIri } from 'src/containers/ProjectDiagram/utils/geoData';
import { removeLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { cleanupModelConceptHierarchyMappings } from 'src/containers/ProjectDiagram/utils/mapping/cleanupModelConceptHierarchyMappings';
import { removeMappingsForNode } from 'src/containers/ProjectDiagram/utils/mapping/removeMappingsForNode';
import { removeDomainFromAllAttributesData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/removeDomainFromAllAttributesData';
import { removeAllHierarchiesFromModelConceptClass } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/removeAllHierarchiesFromModelConceptClass';
import { disconnectAllRelationshipsFromClass } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/disconnectAllRelationshipsFromClass';
import { removeProjectModelIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';

// use useRemoveModelConceptClass() since it also
// clears the diagram and closes drawers if necessary
export const removeModelConceptClass =
  (data: ModelConceptClass) => (model: Model) => {
    removeAllHierarchiesFromModelConceptClass(data)(model);
    disconnectAllRelationshipsFromClass(data)(model);
    removeDomainFromAllAttributesData(data.value)(model);

    removeMappingsForNode(data.key)(model);
    cleanupModelConceptHierarchyMappings(model);

    model.removeNodeData(data);
    removeColorIdForIri(data.value)(model);
    removeDescriptionForIri(data.value)(model);
    removeGeoDataForIri(data.value)(model);
    removeLabelForIri(data.value)(model);
    removeProjectModelIri(data.value)(model);
  };
